import { Locale } from '@ps-smart-cp/ppfw-client';

const isThisIncludeNameConfig = {
  include: new Map([[Locale.ja, '含める']]),
  notInclude: new Map([[Locale.ja, '含めない']]),
  onlyApplicable: new Map([[Locale.ja, '該当のみ']]),
};

export { isThisIncludeNameConfig };
